import { requestFetch } from '@repo/common-utils';
import { WorkingPlatform } from '@repo/platform';

import { RequestPayload } from '@/lib/types/content';

export const requestChat = (messages: RequestPayload, abortController: AbortController | null, chatMode?: string, site?: WorkingPlatform) => {
  return requestFetch(
    `${process.env.NEXT_PUBLIC_SENA_API_SERVER}/api/old/chat/completions`,
    {
      messages,
      mode: chatMode || null,
      stream: true,
      site: site || 'web'
    },
    {
      method: 'POST',
      signal: abortController?.signal
    }
  );
};
